// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { useAllFeatures } from '@tectonics/prs/payment-spec';
import { getFeatureByName } from '@tectonics/prs/feature';

import bancoDoBrasilSrc from './bancodobrasil.svg';
import banrisulSrc from './banrisul.svg';
import bradescoSrc from './bradesco.svg';
import caixaSrc from './caixa.svg';
import itauSrc from './itau.svg';
import santanderSrc from './santander.svg';

export function DisplayBankBrands(): Node {
  const allFeatures = useAllFeatures();
  const displayBankAcceptsBrandFeature = getFeatureByName(allFeatures, 'display_tef_bank_accepts_brand');

  if (displayBankAcceptsBrandFeature && displayBankAcceptsBrandFeature.traits) {
    return (
      <Root>
        {displayBankAcceptsBrandFeature.traits.map(trait => (
          <BankBrandImageWrapper key={trait}>
            <BankBrandImage src={getBankBrandImageSrc(trait)} alt={trait} />
          </BankBrandImageWrapper>
        ))}
      </Root>
    );
  }

  return null;
}

const Root = styled.div`
  height: 100%;
  display: flex;
`;

const BankBrandImageWrapper = styled.div`
  flex-grow: 1;
  padding-left: 4px;
`;

const BankBrandImage = styled.img`
  height: 100%;
  width: 100%;
`;

function getBankBrandImageSrc(bankBrand: string): string {
  switch (bankBrand) {
    case 'bancodobrasil':
      return bancoDoBrasilSrc;

    case 'banrisul':
      return banrisulSrc;

    case 'bradesco':
      return bradescoSrc;

    case 'caixa':
      return caixaSrc;

    case 'itau':
      return itauSrc;

    case 'santander':
      return santanderSrc;

    default:
      throw new Error(`Display bank brand: there is no source for "${bankBrand}"`);
  }
}
